module.exports = "/images/ingredients.png";